import { General } from "@/features/settings/general";

export const Route = createFileRoute({
  component: General,
});
